import React from 'react';
import styled from 'styled-components';
import PDFIcon from '../assets/images/PDFIcon.png';

interface ExportButtonProps {
  pc?: boolean; // Optional로 설정 (필수 속성이 아님)
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}

const ExportButtonContainer = styled.button<{ $pc?: boolean }>`
  width: 130px;
  padding: 6px 10px;
  background-color: ${(props) => props.theme.colors.sub2Color};
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  display: ${(props) =>
    props.$pc === undefined || props.$pc
      ? 'flex'
      : 'none'}; /* pc가 없거나 true면 flex */
  align-items: center;
  justify-content: space-between;
  gap: 5px;

  &:hover {
    background-color: ${(props) => props.theme.colors.sub2HoverColor};
  }

  img {
    width: 20px;
  }

  @media (max-width: 768px) {
    width: 100px !important;
    display: ${(props) =>
      props.$pc === undefined
        ? 'flex'
        : props.$pc
          ? 'none'
          : 'flex'}; /* 모바일에서 undefined도 flex */
    padding: 5px;
    font-size: 9px;
    img {
      width: 15px;
    }
  }

  @media (max-width: 350px) {
    font-size: 9px;
    img {
      width: 10px;
    }
  }
`;

const ExportButton: React.FC<ExportButtonProps> = ({ onClick, pc }) => (
  <ExportButtonContainer onClick={onClick} $pc={pc}>
    <img src={PDFIcon} alt="PDFIcon" /> Export to PDF
  </ExportButtonContainer>
);

export default ExportButton;
